import BaseMixin from "../../../mixins/BaseMixin"
import PageMixin from "../../../mixins/PageMixin"
import template from "./ApplicationSubmitted.html"
import Application from "Models/Application"

export default {

  mixins: [BaseMixin, PageMixin],

  template: template,

  data: function() {
    return {
      application: new Application()
    }
  },

  async mounted() {
    this.ready()
  },

  methods: {
    searchAgain() {
      this.router.push(this.link(''))
    },
    backToResults() {
      this.router.push(this.link(`search/${this.$route.params.searchId}`))
    }
  }

}
